import type React from 'react';

import { defaultWebclientConfig } from '../../../../helpers/webclientHelper';
import { useWebclientActions } from '../../../../hooks/settings/webclients/useWebclientActions';
import type { WebclientFormData } from '../../../../interfaces/IWebclient';
import WebclientDataModal from './WebclientDataModal';

export const CreateWebclientConfigModal: React.FC = () => {
  const { createWebclientConfig } = useWebclientActions();

  const onSave = (data: WebclientFormData) => {
    return createWebclientConfig(data.name, data.config);
  };

  return (
    <WebclientDataModal
      data={defaultWebclientConfig}
      name='New config'
      onSubmit={onSave}
    />
  );
};

export default CreateWebclientConfigModal;
